import styles from "./StockShortsReports.module.scss";
import { FC, useEffect, useState } from "react";
import { getPositionList, getStockShortsChanges } from "@/controllers/stock-shorts";
import { Stock } from "@/models/stock";
import Module from "@/components/module/Module";
import StockShortsInterestChart from "../stock-shorts-interest-chart/StockShortsInterestChart";
import Image from "next/legacy/image";
import { DataGrid, MemoizedDataGrid } from "../data-grid/DataGrid";
import { Box, useMediaQuery } from "@mui/material";

interface PropsTypes {
    stock: Stock;
}

const StockShortsReports: FC<PropsTypes> = ({ stock }) => {
    const [region, setRegion] = useState(null);
    const isMobile = useMediaQuery("(max-width: 1919px)");

    useEffect(() => {
        setRegion(stock.shorts_type);
    }, [stock]);

    return (
        <div className={styles.StockShortsReports}>
            <style jsx>{`
                .${styles.tables} {
                    height: ${stock.shorts_type === "ESMA" ? "calc(100% - 5px)" : "100%"};
                }
                .${styles.tables} > div {
                    height: ${stock.shorts_type === "ESMA" ? "50%" : "100%"};
                }
            `}</style>
            <div className={styles.chart}>
                <Module title={`Short Interest Charts for ${stock.exchangesymbol}:${stock.ticker}`} help={{ moduleId: "short_interest_chart", modulePage: "V2_stock_short_interest" }} allowFullscreen noPadding={{ source: "body", type: "mobile" }}>
                    <StockShortsInterestChart stock={stock} officialReports />
                </Module>
            </div>
            <div className={styles.tables}>
                {stock.shorts_type === "ESMA" && (
                    <div className={styles["largest-positions"]}>
                        <Module
                            title={`Current Short Interest Positions in ${stock.exchangesymbol}:${stock.ticker}`}
                            help={{ moduleId: "largest_positions", modulePage: "V2_stock_short_interest" }}
                            settingsComponent={
                                <Box sx={{ display: "flex" }}>
                                    <Image unoptimized src={`/assets/${isMobile ? "ortex-icon.png" : "ortex-logo-h.png"}`} alt="ortex-logo" width={isMobile ? 20 : 120} height={isMobile ? 20 : 25} />
                                </Box>
                            }
                            allowFullscreen
                        >
                            <DataGrid fetcher={getPositionList} regionId={stock.tradingitem_id} data={region} tableId="largest-positions" />
                        </Module>
                    </div>
                )}
                <div className={styles["exchange-reported"]}>
                    <Module
                        title={`Official Short Interest Position Changes in ${stock.exchangesymbol}:${stock.ticker}`}
                        help={{ moduleId: "exchange_reported", modulePage: "V2_stock_short_interest" }}
                        settingsComponent={
                            <Box sx={{ display: "flex" }}>
                                <Image unoptimized src={`/assets/${isMobile ? "ortex-icon.png" : "ortex-logo-h.png"}`} alt="ortex-logo" width={isMobile ? 20 : 120} height={isMobile ? 20 : 25} />
                            </Box>
                        }
                        allowFullscreen
                    >
                        {stock.shorts_type === "ESMA" && <DataGrid fetcher={getStockShortsChanges} key="changes" regionId={stock.tradingitem_id} tableId="shorts-reports-changes" />}
                        {stock.shorts_type === "FINRA" && <MemoizedDataGrid data={{ region: stock.shorts_type, id: stock.tradingitem_id }} fetcher={getPositionList} key="finra" regionId={stock.tradingitem_id} />}
                    </Module>
                </div>
            </div>
        </div>
    );
};

export default StockShortsReports;
